import React, {useEffect, useState} from 'react';
import WishlistHeader from '@wishlist/components/WishlistHeader.jsx';
import WishlistItemContainer from '@wishlist/components/WishlistItemContainer';
import ChangeWishlistItemControl from '@wishlist/components/change-item-onsite/ChangeWishlistItemControl';
import ChangeItemLayer from '@core/scripts/components/change-item/ChangeItemLayer';
import {Alert, Grid, Typography} from '@bonprix/design-system';
import RecommendationSliderDeSy from '@personalization/scripts/components/RecommendationSliderDeSy';
import {TrinityEvents} from '@checkout/components/tracking/trinity-events.ts';
import {Page} from '@checkout/components/tracking/model/Page.ts';
import {EventObjectType} from '@checkout/components/tracking/model/EventObjectType.ts';
import WindowManager from '@core/scripts/components/window-manager';
import {Constants} from '@article-overview/components/view-constants';

interface WishlistProps {
    device: any;
    hasEmbeddedSwiper: boolean;
    initialWishlistItems: any[];
    initialWishlistSortOption: string;
    isWishlistEmpty: boolean;
    pageType: string;
    pageViewId: string;
    pointOfSaleId: string;
    sliderType: string;
    swiperDataUrl: string;
    swiperParamsString: string;
    texts: any;
    userIsLoggedIn: boolean;
    wishlistCount: number;
}

export default function Wishlist(props: WishlistProps) {
    const {
        device,
        hasEmbeddedSwiper,
        initialWishlistItems,
        initialWishlistSortOption,
        isWishlistEmpty,
        pageType,
        pageViewId,
        pointOfSaleId,
        sliderType,
        swiperDataUrl,
        swiperParamsString,
        texts,
        wishlistCount,
        userIsLoggedIn
    } = props;

    WindowManager.setSpecificTabDataItem(Constants.POINT_OF_SALE_ID, pointOfSaleId);

    const [isWishlistHintVisible, setIsWishlistHintVisible] = useState<boolean>(!userIsLoggedIn && isWishlistEmpty);
    const [wishlistItems, setWishlistItems] = useState([...initialWishlistItems]);

    useEffect(() => {
        if (isWishlistEmpty) {
            const attributes = TrinityEvents.getViewAttributes(
                'emptyWishlist', Page.WISHLIST, EventObjectType.UNDEFINED);
            TrinityEvents.createAndSendTrinityEvent(2, "VIEW_WISHLIST_EMPTY", attributes);
        }
    }, [isWishlistEmpty])

    const max_width = 1000;
    const isHeaderVisible: boolean = device.type != 'APP';
    const paramStringWithPageViewId = pageViewId ? swiperParamsString + '&pageViewId=' + pageViewId : swiperParamsString;

    const handleOnClose = () => {
        setIsWishlistHintVisible(false);

        const attributes = TrinityEvents.getClickAttributes(
            'emptyWishlist_close_info', Page.WISHLIST, EventObjectType.BUTTON);
        TrinityEvents.createAndSendTrinityEvent(2, "CLICK_WISHLIST_EMPTY", attributes);
    };

    return (
        <>

            {
                isWishlistHintVisible && (
                    <Alert isOpen={isWishlistHintVisible} onClose={handleOnClose} status="info" showCloseIcon={true}>
                        <Typography component="span">{texts.wishlist_emptyWishlistHint}</Typography>
                    </Alert>
                )
            }
            {isHeaderVisible && (
                <WishlistHeader
                    wishlistCount={wishlistCount}
                    texts={texts}
                />
            )}
            <ChangeWishlistItemControl origin="wishlist" />
            <ChangeItemLayer
                layerOrigin={pageType}
                channelId={0}
                pageType={pageType}
                fkIdOverride={-95}
                isLastCheckPage={false}
            />
            <WishlistItemContainer
                pointOfSaleId={pointOfSaleId}
                wishlistItems={wishlistItems}
                setWishlistItems={setWishlistItems}
                initialWishlistSortOption={initialWishlistSortOption}
                texts={texts}
                userIsLoggedIn={userIsLoggedIn}
            />

            {wishlistItems?.length > 0 && (
                <Grid>
                    <Grid.Item s={1} />
                    <Grid.Item s={10}>
                        <RecommendationSliderDeSy
                            dataUrl={swiperDataUrl}
                            paramString={paramStringWithPageViewId}
                            productCardTexts={texts}
                            max_width={max_width}
                            disableAutomaticScrollRestoration={false}
                        />
                    </Grid.Item>
                    <Grid.Item s={1} />
                </Grid>
              )
            }
        </>
    );
}